import script from "./Suggestions.vue?vue&type=script&setup=true&lang=js"
export * from "./Suggestions.vue?vue&type=script&setup=true&lang=js"

import "./Suggestions.vue?vue&type=style&index=0&id=0bc167f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc167f8"]])

export default __exports__